export const API_POST_LOGIN = "login/user";
export const API_POST_POLICY_DETAILS_HEADER = "policy/header";
export const API_POST_POLICY_ACTIVITIES = "policy/activity";
export const API_POST_POLICY_CLAIMS_ACTIVITIES = "claim/history/details";
export const API_POST_POLICIES = "dashboard/customer/policies";
export const API_POST_CLAIMS = "dashboard/customer/claims";
export const API_POST_POLICY_RISKS = "policy/risks";
export const API_POST_INSURANCE_DOCUMENTS = "";
export const API_POST_LEIN_HOLDERS = "policy/lienholder";
export const API_POST_COVERAGES_AND_COVERAGES = "policy/coverages";
export const API_POST_DOCUMENTS = "policy/documents";
export const API_GET_DOCUMENT_CONTENT = "document/policies";
export const API_GET_CLAIM_TRANSACTION_DOCUMENT_CONTENT = "document/claim-demo";
export const POST_FILE_A_CLAIM = "claim/fnol";
export const POST_FILE_A_CLAIM_DUMMY = "claim/fileAClaim";
export const POST_CLAIM_HISTORY = "claim/history";
export const API_POST_BILLING_DETAILS = "policy/billingDetails";
export const API_GET_DOWNLOAD_ID_CARD = "document/insureCard";
export const API_GET_VIEW_OR_DOWNLOAD_DOCUMENT_OR_ID_CARD = "document";
export const API_GET_VIEW_OR_DOWNLOAD_DOCUMENT_PA = "document";
export const API_POST_VEHICLE_DETAILS = "policy/vin/details";
export const API_GET_ADD_VEHICLE_FORM_SCHEMA = "form/addVehicle";
export const API_GET_EDIT_GARAGE_LOCATION_PA_FORM_SCHEMA =
  "form/editGarageLocationPA";
export const API_GET_LOOKUP_VALUES = "lookup";
export const API_POLICY_CHANGE = "policy/policyChange";
export const API_GET_ADD_DRIVER_FORM_FIELDS_JSON = "form/addDriver";
export const API_GET_ADD_LIENHOLDER_FORM_FIELDS_JSON = "form/addLienholder";
export const API_GET_FILE_A_CLAIM_FORM_FIELDS_JSON = "form";
export const API_POST_INSURED_ADDRESS_DETAILS = "policy/insured/address";
export const API_GET_TASKS = "dashboard/customer/tasks ";
export const API_GET_TASKS_POLICY_NUMBER = "dashboard/customer/tasks";
export const API_POST_OPTED_AND_UNOPTED_COVERAGES = "policy/coverage/options  ";
export const API_POST_DELETE_TASK = "agent/delete";
export const API_POST_SENT_OTP = "auth/sendOtp";
export const API_POST_VALIDATE_OTP = "auth/verifyOtp";
export const API_POST_EMAIL_OR_MOBILE_LOGIN = "login/user/emailOrMobile";
export const API_GET_PREFERENCE_TYPES = "lookup/type/preferences";
export const API_POST_USER_PREFERENCES = "customer/preferences/add";
export const API_GET_USER_PREFERENCES = "customer/preferences/get";
export const API_DELETE_USER_PREFERENCES = "customer/preferences/delete";
export const API_POST_FORM_JSON = "form/add";
export const API_GET_FORMS = "form/get";
export const API_POST_CUSTOMER_AGENTS = "dashboard/customer/agents";
export const API_POST_CUSTOMER_POLICIES = "dashboard/customer/policies";
export const API_GET_UPDATE_PROPERTY_DETAILS_FORM_FIELDS_JSON = "form/updatePropertyDetails";
export const API_GET_UPDATE_BUILDING_SAFETY_FEATURES_FORM_FIELDS_JSON = "form/updateBuildingSafetyFeatures";
export const API_GET_UPDATE_USAGE_AND_OCCUPANCY_FORM_FIELDS_JSON = "form/updateUsageAndOccupancy";
export const API_GET_UPDATE_DWELLING_DETAILS_FORM_FIELDS_JSON = "form/updateDwellingDetails";
export const API_GET_UPDATE_SAFETY_SECURITY_FEATURES_FORM_FIELDS_JSON = "form/updateSafetySecurityFeatures";
export const API_POST_UPDATE_USAGE_AND_OCCUPANCY = "form/updateOccupancyAndUsage";
/** For Lookup */
export const API_GET_LOOKUP_LIST = "lookupMaster/names";
export const API_GET_LOOKUP_LIST_BY_NAME = "lookup";
export const API_POST_LOOKUP_ADD = "lookup/insert";
export const API_DELETE_LOOKUP_ADD = "lookup";
/** End */

export const API_DELETE_FORM = "form";
export const API_GET_FEATURES = "features/getAll";
export const API_GET_UI_SETTINGS = "uiSettings/get";
export const API_POST_UI_SETTINGS = "uiSettings/add";
export const API_POST_FEATURES = "features/update ";
export const API_POST_ADMIN_LOGIN = "admin/login";
export const API_POST_ADMIN_RESET_PASSWORD = "admin/reset-password";
export const API_POST_ADMIN_FORGOT_PASSWORD = "admin/forgot-password";
export const API_POST_ADMIN_UPDATE_PASSWORD = "admin/update-password";
export const API_POST_ADMIN_DETAILS = "admin/details";
export const API_GET_ADMIN_PASSWORD_CONFIG = "admin/password-config/get";
export const API_UPDATE_ADMIN_PASSWORD_CONFIG = "admin/password-config/update";
export const API_POST_ADMIN_ROLE_CREATE = "admin/roles/create";
export const API_GET_ADMIN_ROLE = "admin/roles/get";
export const API_GET_ADMIN_PERMISSIONS = "admin/roles/permissions";
export const API_GET_ADMIN_AUDIT_LOG = "admin/roles/audit/logs";
export const API_DELETE_ADMIN_ROLE = "admin/roles/delete";
export const API_UPDATE_ADMIN_ROLE = "admin/roles/update";
export const API_GET_ADMIN_ASSIGNED_USERS = "admin/roles/users";
export const API_GET_ALL_ADMIN_ROLES_NAMES = "admin/roles/names";
export const API_ADMIN_ADD_ASSIGNED_USER = "admin/roles/add/user";
export const API_UPDATE_ADMIN_ASSIGNED_USER = "admin/roles/update/role";
export const API_DELETE_ADMIN_ASSIGNED_USER = "admin/roles/delete/user";
export const API_GET_ALL_ADMIN_USERS = "admin/roles/users";
export const API_GET_ALL_CUSTOMER_ACTIVITY = "admin/customer-activity";
export const API_GET_ALL_CUSTOMER_ACTIVITY_BY_DATE_RANGE =
  "admin/customer-activity/dateRange";

export const API_GET_USER_LOGOUT = "logout/user";
export const API_GET_ADMIN_LOGOUT = "logout/admin";
export const API_GET_ADMIN_ENCRYPTED_SECRET_KEYS = "secrets/getAllSecrets";
export const API_GET_ADMIN_DECRYPTED_SECRET_KEY = "secrets/getSecret";
export const API_PUT_ADMIN_DECRYPTED_SECRET_KEY = "secrets/updateSecret";
export const API_GET_ADMIN_ALL_USERS = "admin/getAll";
export const API_POST_ADMIN_ADD_USER = "admin/signUp";
export const API_PUT_UPDATE_ADMIN_USER = "admin/update";
export const API_DELETE_ADMIN_USER = "admin/deleteUser";
export const API_POST_INVITE_ADMIN = "admin/sendInvite";
export const API_GET_ALL_LOGIN_ACTIVITY = "user/login-activity";
export const API_GET_LOGIN_ACTIVITY_BY_FILTER = "user/login-activity/filter";
export const API_GET_ALL_CONVERSATION_SESSIONS = "/chatHistory";
export const API_GET_CONVERSATION_ANALYSIS = "/chat/analysis";
export const API_GET_CONVERSATION_BY_FILTER = "/chatHistory/customRange";
export const API_GET_CONVERSATION_BY_SESSION = "/chatHistory/get-conversation";
export const API_GET_BILLING_TRANSACTIONS = "policy/billing/activity";

export const API_GET_CMS_CONTENT_TYPES = "cms/content-type/getAll";
export const API_POST_CMS_CREATE_CONTENT_TYPE = "cms/content-type/create";
export const API_POST_CMS_CREATE_CONTENT = "cms/content/create";
export const API_POST_CMS_UPDATE_CONTENT = "cms/content/update";
export const API_GET_CMS_CONTENT = "cms/content/getAll";
export const API_DELETE_CMS_CONTENT = "cms/content/delete";
export const API_GET_IA_METRICS = "admin/IA-Metrics/getAll";
export const API_GET_IA_CUSTOM_RANGE = "admin/IA-Metrics/customRange";
export const API_POST_CREATE_COMMUNICATION_TEMPLATE =
  "admin/email-templates/create";
export const API_GET_ALL_COMMUNICATION_TEMPLATES =
  "admin/email-templates/get-all";
export const API_DELETE_COMMUNICATION_TEMPLATE = "admin/email-templates/delete";
export const API_PUT_COMMUNICATION_TEMPLATE = "admin/email-templates/update";
export const API_POST_REVERT_COMMUNICATION_TEMPLATE_VERSION =
  "admin/email-templates";
export const API_GET_COMMUNICATION_TEMPLATE_VERSION_HISTORY =
  "admin/email-templates/get";
export const API_GET_PROMPT_BY_KEY = "admin/prompt/getbykey";
export const API_UPDATE_PROMPT_BY_KEY = "admin/prompt/update";

/** Agent */

export const API_POST_AGENT_LOGIN = "agent/login";
export const API_GET_AGENT_LOGOUT = "agent/logout";
export const API_POST_AGENT_POLICIES = "agent/policies";
export const API_POST_AGENT_POLICY_METRICS = "agent/policy-metrics";
export const API_GET_ADD_TASK_FORM_SCHEMA = "form/addTask";
export const API_POST_ADD_TASK = "agent/add-task";
export const API_GET_AGENT_TASKS = "agent/get-tasks";
export const API_POST_AGENT_SEARCH = "agent/search";
export const API_POST_AGENT_CUSTOMER_SEARCH = "agent/customer-search";
export const API_POST_AGENT_CUSTOMER_METRICS = "agent/customer/metrics";
export const API_EDIT_ADD_TASK = "agent/update";
export const API_POST_ADD_NOTE = "agent/add-note";
export const API_GET_NOTE = "agent/get";
export const API_PUT_EDIT_NOTE = "agent/update-note";
export const API_DELETE_NOTE = "agent/delete-note";
export const API_GET_OPEN_TASKS = "agent/tasks";
export const API_POST_AGENT_CUSTOMER_DETAILS = "agent/customer/details";
export const API_GET_AI_STORY_BY_ID = "ia/story";
